import { useId, type ReactNode } from "react";

import { Button, type ButtonProps } from "./Button";

export function IconButton({
  label,
  tooltip,
  icon,
  className,
  containerClassName,
  ...props
}: Omit<
  ButtonProps,
  "aria-label" | "children" | "iconLeft" | "iconRight" | "title"
> & {
  label: string;
  tooltip: string;
  icon: ReactNode;
  containerClassName?: string;
}) {
  const tooltipId = useId();
  return (
    <span
      className={["ui-icon-button-container", containerClassName]
        .filter(Boolean)
        .join(" ")}
    >
      <Button
        {...props}
        className={["ui-icon-button", className].filter(Boolean).join(" ")}
        aria-label={label}
        aria-describedby={tooltipId}
      >
        {icon}
      </Button>
      <span id={tooltipId} className="ui-icon-button__tooltip" role="tooltip">
        {tooltip}
      </span>
    </span>
  );
}
